// Resolution order for every value: deploy-time injected window.RUNTIME_CONFIG
// (written by FrontendStack) → build-time REACT_APP_* env var → empty.
// No hardcoded production fallbacks: a missing value surfaces as an error
// instead of silently pointing at a stale environment.
const runtime =
  (typeof window !== "undefined" && window.RUNTIME_CONFIG) || {};

const config = {
  API_BASE_URL:
    runtime.API_BASE_URL || process.env.REACT_APP_API_BASE_URL || "",

  COGNITO_DOMAIN:
    runtime.COGNITO_DOMAIN || process.env.REACT_APP_COGNITO_DOMAIN || "",

  COGNITO_CLIENT_ID:
    runtime.COGNITO_CLIENT_ID || process.env.REACT_APP_COGNITO_CLIENT_ID || "",

  REDIRECT_URI:
    process.env.REACT_APP_REDIRECT_URI ||
    (typeof window !== "undefined" ? window.location.origin + "/callback" : ""),

  // Whether the AI advisor (AgentCore) backend is deployed. When false the UI
  // hides the AI recommendation + agent dashboard instead of calling routes that
  // don't exist. Defaults off so a base (agent-disabled) deploy degrades cleanly.
  AGENT_ENABLED:
    String(runtime.AGENT_ENABLED ?? process.env.REACT_APP_AGENT_ENABLED ?? "")
      .toLowerCase() === "true",
};

const missing = Object.entries(config)
  .filter(([key, value]) => key !== "REDIRECT_URI" && key !== "AGENT_ENABLED" && !value)
  .map(([key]) => key);
if (missing.length && typeof console !== "undefined") {
  console.error(
    `[config] Missing runtime configuration: ${missing.join(", ")}. ` +
      `Expected window.RUNTIME_CONFIG (deploy-time) or REACT_APP_* env vars.`
  );
}

export default config;
